module.exports = __webpack_public_path__ + "static/media/Temp1small.d31b8762.png";